/**
 * Created by Christof Sander on 16.06.2016.
 */

const utils = require('../../lib/utils');

module.exports = {
	config: {
		lastMileSelector: 'section.treeContainer',
		registerType: 'tree',
		maxSortValue: 0,
		minSortValue: 1,
		minIndex: Number.MAX_SAFE_INTEGER,
		maxIndex: 0,
		focusAble: true,
		focusPriority: 0,
		treeConfig: {
			core: {
				// 'animation' : 0,
				// 'check_callback' : true,
				// 'themes' : { 'stripes' : true },
				multiple:   false,
				data:       undefined
			},
			types: {
				'#': {
					// 'max_children' : 1,
					// 'max_depth' : 4,
					// valid_children : ['root']
				},
				// root: {
				// 	icon: 'flag',
				// },
				// PAGE TREE TYPES
				page: {
					icon: 'fi fi-route'
					// valid_children: ['default']
				},
				default: {
					icon: 'fi fi-routeFallback'
					// valid_children: ['default','file']
				},
				home: {
					icon: 'fi fi-homeRoute'
					// valid_children: []
				},
				lang: {
					// icon: 'fi fi-home',
					// valid_children: []
				},

				// PAGE CONTENT TREE TYPES
				section: {
					icon: 'fi fi-section'
				},
				component: {
					icon: 'fi fi-component'
				},
				group: {
					icon: 'fi fi-group'
				},
				form: {
					icon: 'fi fi-form'
				},

				// COMPONENT TREE TYPES
				templateAtom: {
					icon: 'fi fi-leaf'
				},

				// ATOM TREE TYPES
				atom: {
					icon: 'fi fi-atom'
				},

				// SERVICE TREE TYPES
				service: {
					icon: 'fi fi-service'
				},
				assignedService: {
					icon: 'fi fi-assignedService'
				},

				// USER TREE TYPES
				user: {
					icon: 'fi fi-user'
				},

				// SERVICE USER TREE TYPES
				serviceUser: {
					icon: 'fi fi-serviceUser'
				},

				// SCOPE TREE TYPES
				scope: {
					icon: 'fi fi-scope'
				},
				scopeRole: {
					icon: 'fi fi-scopeRole'
				},

				// ROLE TREE TYPES
				privilege: {
					icon: 'fi fi-privilege'
				},

				// LAYOUT TREE TYPES
				layout: {
					icon: 'fi fi-layout'
				},

				// CATEGORY TREE TYPES
				category: {
					icon: 'fi fi-category'
				},
				categoryData: {
					icon: 'fi fi-categoryData'
				},
				tagScope: {
					icon: 'fi fi-hashtag'
				},

				// CLIENT TREE TYPES
				client: {
					icon: 'fi fi-client'
				},
				database: {
					icon: 'fi fi-database'
				},
				banner: {
					icon: 'fi fi-banner'
				},
				// NEWSLETTER TREE TYPES
				newsletter: {
					icon: 'fi fi-newsletter'
				},
				mailinglist: {
					icon: 'fi fi-mailinglist'
				}
			},
			plugins: [
				// 'contextmenu', 'dnd', 'search',
				// 'state', 'types', 'wholerow'
				'search',
				'types'
				// 'contextmenu',
				// 'dnd'
			],
			search: {
				show_only_matches: true,
				show_only_matches_children: true
			}
		}
	},

	model: {
		// name: 'German',
		// tree: [
		// 	// {
		// 	// 	id          : "string", // will be autogenerated if omitted
		// 	// 	text        : "string", // node text
		// 	// 	icon        : "string", // string for custom
		// 	// 	state       : {
		// 	// 		opened    : true,  // is the node open
		// 	// 		disabled  : false,  // is the node disabled
		// 	// 		selected  : true,  // is the node selected
		// 	// 	},
		// 	// 	children    : [
		// 	// 		{
		// 	// 			id          : "string", // will be autogenerated if omitted
		// 	// 			text        : "string", // node text
		// 	// 			icon        : "string", // string for custom
		// 	// 			state       : {
		// 	// 				opened    : true,  // is the node open
		// 	// 				disabled  : false,  // is the node disabled
		// 	// 				selected  : true,  // is the node selected
		// 	// 			},
		// 	// 			children    : [
		// 	//
		// 	// 			],  // array of strings or objects
		// 	// 			li_attr     : {},  // attributes for the generated LI node
		// 	// 			a_attr      : {}  // attributes for the generated A node
		// 	// 		},
		// 	// 		{
		// 	// 			id          : "string", // will be autogenerated if omitted
		// 	// 			text        : "string", // node text
		// 	// 			icon        : "string", // string for custom
		// 	// 			state       : {
		// 	// 				opened    : true,  // is the node open
		// 	// 				disabled  : false,  // is the node disabled
		// 	// 				selected  : true,  // is the node selected
		// 	// 			},
		// 	// 			children    : [
		// 	//
		// 	// 			],  // array of strings or objects
		// 	// 			li_attr     : {},  // attributes for the generated LI node
		// 	// 			a_attr      : {}  // attributes for the generated A node
		// 	// 		},
		// 	// 		{
		// 	// 			id          : "string", // will be autogenerated if omitted
		// 	// 			text        : "string", // node text
		// 	// 			icon        : "string", // string for custom
		// 	// 			state       : {
		// 	// 				opened    : true,  // is the node open
		// 	// 				disabled  : false,  // is the node disabled
		// 	// 				selected  : true,  // is the node selected
		// 	// 			},
		// 	// 			children    : [
		// 	// 				{
		// 	// 					id          : "string", // will be autogenerated if omitted
		// 	// 					text        : "string", // node text
		// 	// 					icon        : "string", // string for custom
		// 	// 					state       : {
		// 	// 						opened    : true,  // is the node open
		// 	// 						disabled  : false,  // is the node disabled
		// 	// 						selected  : true,  // is the node selected
		// 	// 					},
		// 	// 					children    : [
		// 	// 						{
		// 	// 							id          : "string", // will be autogenerated if omitted
		// 	// 							text        : "string", // node text
		// 	// 							icon        : "string", // string for custom
		// 	// 							state       : {
		// 	// 								opened    : true,  // is the node open
		// 	// 								disabled  : false,  // is the node disabled
		// 	// 								selected  : true,  // is the node selected
		// 	// 							},
		// 	// 							children    : [
		// 	//
		// 	// 							],  // array of strings or objects
		// 	// 							li_attr     : {},  // attributes for the generated LI node
		// 	// 							a_attr      : {}  // attributes for the generated A node
		// 	// 						},
		// 	// 						{
		// 	// 							id          : "string", // will be autogenerated if omitted
		// 	// 							text        : "string", // node text
		// 	// 							icon        : "string", // string for custom
		// 	// 							state       : {
		// 	// 								opened    : true,  // is the node open
		// 	// 								disabled  : false,  // is the node disabled
		// 	// 								selected  : true,  // is the node selected
		// 	// 							},
		// 	// 							children    : [
		// 	//
		// 	// 							],  // array of strings or objects
		// 	// 							li_attr     : {},  // attributes for the generated LI node
		// 	// 							a_attr      : {}  // attributes for the generated A node
		// 	// 						},
		// 	// 						{
		// 	// 							id          : "string", // will be autogenerated if omitted
		// 	// 							text        : "string", // node text
		// 	// 							icon        : "string", // string for custom
		// 	// 							state       : {
		// 	// 								opened    : true,  // is the node open
		// 	// 								disabled  : false,  // is the node disabled
		// 	// 								selected  : true,  // is the node selected
		// 	// 							},
		// 	// 							children    : [
		// 	//
		// 	// 							],  // array of strings or objects
		// 	// 							li_attr     : {},  // attributes for the generated LI node
		// 	// 							a_attr      : {}  // attributes for the generated A node
		// 	// 						},
		// 	// 						{
		// 	// 							id          : "string", // will be autogenerated if omitted
		// 	// 							text        : "string", // node text
		// 	// 							icon        : "string", // string for custom
		// 	// 							state       : {
		// 	// 								opened    : true,  // is the node open
		// 	// 								disabled  : false,  // is the node disabled
		// 	// 								selected  : true,  // is the node selected
		// 	// 							},
		// 	// 							children    : [
		// 	//
		// 	// 							],  // array of strings or objects
		// 	// 							li_attr     : {},  // attributes for the generated LI node
		// 	// 							a_attr      : {}  // attributes for the generated A node
		// 	// 						},
		// 	// 					],
		// 	// 					li_attr     : {},  // attributes for the generated LI node
		// 	// 					a_attr      : {}  // attributes for the generated A node
		// 	// 				}
		// 	// 			],  // array of strings or objects
		// 	// 			li_attr     : {},  // attributes for the generated LI node
		// 	// 			a_attr      : {}  // attributes for the generated A node
		// 	// 		},
		// 	// 		{
		// 	// 			id          : "string", // will be autogenerated if omitted
		// 	// 			text        : "string", // node text
		// 	// 			icon        : "string", // string for custom
		// 	// 			state       : {
		// 	// 				opened    : true,  // is the node open
		// 	// 				disabled  : false,  // is the node disabled
		// 	// 				selected  : true,  // is the node selected
		// 	// 			},
		// 	// 			children    : [
		// 	//
		// 	// 			],  // array of strings or objects
		// 	// 			li_attr     : {},  // attributes for the generated LI node
		// 	// 			a_attr      : {}  // attributes for the generated A node
		// 	// 		},
		// 	// 	],
		// 	// 	li_attr     : {},  // attributes for the generated LI node
		// 	// 	a_attr      : {}  // attributes for the generated A node
		// 	// }
		// ]
	},

	events: {
		// open: {
		// 	type: 'mouseup',
		// 	action: function(event){
		// 		// middle mouse button
		// 		if( event.which == 2 ) {
		// 			event.preventDefault();
		// 			event.stopImmedatePropagation();
		//
		// 			var $node, $tree, nodeIndex, treeIndex;
		// 			if(($node = $(event.target).closest('li[role="treeitem"]')).length > 0){
		// 				nodeIndex = parseInt($node.attr('id'));
		// 				if(($tree = $node.closest('.base_trees_tree')).length > 0){
		// 					treeIndex = parseInt($tree.data('componentIndex'));
		// 					if(nodeIndex && treeIndex){
		// 						event.data.component.closest('base_trees_trees', function(treesComponent){
		// 							var buttonData = utils.copy(treesComponent.config.doubleClickButtonData);
		// 							buttonData.componentInCharge = treesComponent;
		// 							if(buttonData.context && buttonData.fieldType){
		// 								treesComponent.model.doubleClickOccurred = true;
		// 								treesComponent.selectNodeByIndex(nodeIndex, treeIndex, true);
		// 								// treesComponent.hideSelectionDependentAreas();
		//
		// 								utils.performButtonAction(undefined, undefined, {}, buttonData).then(function(context){
		// 									// treesComponent.deselectNodeByIndex(nodeIndex, treeIndex, true);
		// 									// treesComponent.showSelectionDependentAreas();
		// 								});
		// 							}
		// 						});
		// 					}
		// 					// else {
		// 					// 	event.stopImmedatePropagation();
		// 					// }
		// 				}
		// 			}
		// 		}
		// 	}
		// },
		//
		// contextMenuButton: {
		// 	type: 'click',
		// 	selector: '.contextMenu > button',
		// 	action: function(event){
		// 		event.preventDefault();
		// 		event.stopImmediatePropagation();
		//
		// 		var $node, $tree, nodeIndex, treeIndex;
		// 		if(($node = $(event.target).closest('li[role="treeitem"]')).length > 0){
		// 			nodeIndex = parseInt($node.attr('id'));
		// 				if(nodeIndex){
		// 					event.data.component.closest('base_trees_trees', function(treesComponent){
		// 						// var buttonData = utils.copy(treesComponent.config.doubleClickButtonData);
		// 						// buttonData.componentInCharge = treesComponent;
		// 						// if(buttonData.context && buttonData.fieldType){
		// 						// 	treesComponent.model.doubleClickOccurred = true;
		// 							treesComponent.selectNodeByIndex(nodeIndex, event.data.component.componentIndex);
		// 							// treesComponent.hideSelectionDependentAreas();
		//
		// 							utils.performButtonAction(event, 'base_trees_trees');
		// 							// utils.performButtonAction(undefined, undefined, {}, buttonData).then(function(context){
		// 								// treesComponent.deselectNodeByIndex(nodeIndex, treeIndex, true);
		// 								// treesComponent.showSelectionDependentAreas();
		// 							// });
		// 						// }
		// 					});
		// 				}
		// 				// else {
		// 				// 	event.stopImmedatePropagation();
		// 				// }
		// 			// }
		// 		}
		//
		// 	}
		// },

		// JSTree Events (for a complete list see: https://www.jstree.com/api/#/?q=.jstree%20Event)
		// 'init.jstree':          function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'init.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'loading.jstree':       function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'loading.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'loaded.jstree':        function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'loaded.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		'ready.jstree': {
			type: 'ready.jstree',
			selector: '.tree',
			delegated: false,
			action: function(event){
				event.data.component.refresh$Instances().addClass('jstree-ready');
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', { eventType: 'ready.jstree', treeComponentIndex: event.data.component.componentIndex, event: event });
			}
		},
		// 'load_node.jstree':     function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'load_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'load_all.jstree':      function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'load_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'model.jstree':         function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'model.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'redraw.jstree':        function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'redraw.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'before_open.jstree':   function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'before_open.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		'open_node.jstree': {
			type: 'open_node.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'open_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event, eventData: eventData });
			}
		},
		// 'after_open.jstree': {
		// 	type: 'after_open.jstree',
		// 	selector: '> .tree',
		// 	delegated: false,
		// 	action: function(event, eventData){
		// 		event.preventDefault();
		// 		event.stopImmediatePropagation();
		// 		event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'after_open.jstree', treeComponentIndex: event.data.component.componentIndex, event: event, eventData: eventData });
		// 	}
		// },
		'close_node.jstree': {
			type: 'close_node.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'close_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event, eventData: eventData });
			}
		},
		// 'after_close.jstree': {
		// 	type: 'after_close.jstree',
		// 	selector: '> .tree',
		// 	delegated: false,
		// 	action: function(event, eventData){
		// 		event.preventDefault();
		// 		event.stopImmediatePropagation();
		// 		event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'after_close.jstree', treeComponentIndex: event.data.component.componentIndex, event: event, eventData: eventData });
		// 	}
		// },
		// 'open_all.jstree':      function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'open_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'close_all.jstree':     function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'close_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'enable_node.jstree':   function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'enable_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'disable_node.jstree':  function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'disable_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'hide_node.jstree':     function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'hide_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'show_node.jstree':     function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'show_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'hide_all.jstree':      function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'hide_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'show_all.jstree':      function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'show_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'activate_node.jstree': function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'activate_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'hover_node.jstree': {
		// 	type: 'hover_node.jstree',
		// 	selector: '> .tree',
		// 	action: function(event, eventData){
		// 		event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
		// 			eventType: 			'hover_node.jstree',
		// 			treeComponentIndex: event.data.component.componentIndex,
		// 			event: 				event,
		// 			eventData:          eventData || {}
		// 		});
		// 	}
		// },
		// 'dehover_node.jstree': {
		// 	type: 'dehover_node.jstree',
		// 	selector: '> .tree',
		// 	action: function(event, eventData){
		// 		event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
		// 			eventType: 			'dehover_node.jstree',
		// 			treeComponentIndex: event.data.component.componentIndex,
		// 			event: 				event,
		// 			eventData:          eventData || {}
		// 		});
		// 	}
		// },
		// 'deselect_node.jstree': function(node, selected, event){
		// 	console.log('deselect', node, selected, event);
		// },
		// 'check_node.jstree':   function(event, eventData){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'check_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event, eventData: eventData }); },
		'select_node.jstree': {
			type: 'select_node.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType:          'select_node.jstree',
					treeComponentIndex: event.data.component.componentIndex,
					event:              event,
					eventData:          eventData,
					autoSelect:         (event.data.component.actualParentComponent.model && event.data.component.actualParentComponent.model.states && event.data.component.actualParentComponent.model.states.autoSelect),
					rightClickInCharge: 		((eventData || {}).event && ((eventData.event.which !== undefined && eventData.event.which > 1) || (eventData.event.data || {}).rightClickInCharge)),
					rightClickIsNormalAction: 	(((eventData || {}).event || {}).data || {}).rightClickIsNormalAction,
				});
			}
		},
		'changed.jstree': {
			type: 'changed.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType:          'changed.jstree',
					treeComponentIndex: event.data.component.componentIndex,
					event:              event,
					eventData:          eventData,
					autoSelect:         (event.data.component.actualParentComponent.model && event.data.component.actualParentComponent.model.states && event.data.component.actualParentComponent.model.states.autoSelect)
				});
			}
		},
		'deselect_node.jstree': {
			type: 'deselect_node.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType:          'deselect_node.jstree',
					treeComponentIndex: event.data.component.componentIndex,
					event:              event,
					eventData:          eventData,
					autoSelect:         (event.data.component.actualParentComponent.model && event.data.component.actualParentComponent.model.states && event.data.component.actualParentComponent.model.states.autoSelect)
				});
			}
		},
		// 'select_all.jstree':    function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'select_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'deselect_all.jstree':  function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'deselect_all.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'set_state.jstree':     function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'set_state.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		'refresh.jstree': {
			type: 'refresh.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType: 'refresh.jstree',
					treeComponentIndex: event.data.component.componentIndex,
					event: event,
					eventData: eventData
				});
			}
		},
		// 'refresh_node.jstree':  function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'refresh_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'set_id.jstree':        function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'set_id.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'set_text.jstree':      function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'set_text.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'create_node.jstree':   function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'create_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'rename_node.jstree':   function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'rename_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'delete_node.jstree':   function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'delete_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		'move_node.jstree': {
			type: 'move_node.jstree',
			selector: '> .tree',
			delegated: false,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType: 'move_node.jstree',
					treeComponentIndex: event.data.component.componentIndex,
					event: event,
					eventData: eventData
				});
			}
		},
		'dnd_start.vakata': {
			type: 'dnd_start.vakata',
			onDocument: true,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType: 'dnd_start.vakata',
					treeComponentIndex: event.data.component.componentIndex,
					event: event,
					eventData: eventData
				});
			}
		},
		'dnd_stop.vakata': {
			type: 'dnd_stop.vakata',
			onDocument: true,
			action: function(event, eventData){
				event.data.component.actualParentComponent.triggerWhenReady('onTreeAction', {
					eventType: 'dnd_stop.vakata',
					treeComponentIndex: event.data.component.componentIndex,
					event: event,
					eventData: eventData
				});
			}
		},
		// 'copy_node.jstree':     function(event, eventData){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'copy_node.jstree', treeComponentIndex: event.data.component.componentIndex, event: event, eventData: eventData }); },
		// 'cut.jstree':           function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'cut.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'copy.jstree':          function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'copy.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'paste.jstree':         function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'paste.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },
		// 'clear_buffer.jstree':  function(event){ event.data.component.actualParentComponent.trigger('onTreeAction', { eventType: 'clear_buffer.jstree', treeComponentIndex: event.data.component.componentIndex, event: event }); },

		'contextmenu': {
			type: 'contextmenu',
			selector: '.jstree-node',
			delegated: true,
			action: function(event, eventData){
				// trigger custom contextmenu if necessary (this is just a fancy way of saying: its a right click ;-)
				if(
					typeof ((event.data || {}).component || {}).hasPlugin === 'function' &&
					!event.data.component.hasPlugin('contextmenu')
				){
					event.preventDefault();
					event.stopImmediatePropagation();

					const jstreeID = $(event.target).closest('.jstree-node').attr('id');
					if(jstreeID){
						if(event.data.component.isSelectedNodeByIndex(jstreeID)) {
							// deselect actual node
							event.data.component.deselectNode(jstreeID)
						} else {
							// deselect previous nodes
							event.data.component.deselectAllNodes()

							// select actual one
							event.data.rightClickInCharge = true
							event.data.rightClickIsNormalAction = true
							event.data.component.selectNodeByIndex(jstreeID, event)
						}
					}
				}
			}
		},
	},

	methods: {
		/**
		 * sanitize resources for the actual tree
		 */
		sanitizeResources: function(){
			// prepare often used elements
			if(!this.actualParentComponent){
				this.parent(function (parentComponent) {
					this.actualParentComponent = parentComponent;
				});
			}

			// get resources if possible
			if(!this.actualParentComponent){
				throw new Error('no parent component found for tree resources');
			}
			this.resourceData.treeData = (this.actualParentComponent.resourceData.trees || {})[this.resourceData.treeIndex];
		},

		/**
		 * this function selects a node if possible and returns false if the node has not been found or true otherwise.
		 *
		 * @param   nodeIndex       int - nodeIndex to select
		 * @param   event        	{} - event which should be passed to jstree.select_node
		 * @returns {boolean} - success
		 */
		selectNodeByIndex: function(nodeIndex, event){
			if(this.refresh$Instances().jstree(true).get_node(nodeIndex) !== false){
				this.model.$tree.jstree(true).select_node(nodeIndex, true, true, event);
				this.keepNodeVisibleByIndex(nodeIndex);
				return true;
			}
			return false;
		},

		/**
		 * returns if the node identified by the given nodeIndex is selected or not.
		 *
		 * @param nodeIndex
		 * @return boolean
		 */
		isSelectedNodeByIndex: function(nodeIndex){
			const jstree = this.refresh$Instances().jstree(true);
			const node = jstree.get_node(nodeIndex);
			return !!jstree.is_selected(node);
		},

		/**
		 * this function is used to scroll to the right position to get the node according to the given nodeIndex visible.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 */
		keepNodeVisibleByIndex: function(nodeIndex){
			try {
				var $node 				= this.model.$tree.jstree(true).get_node(nodeIndex, true);
				var nodeOffsetTop 		= $node.offset().top - this.model.$tree.offset().top;
				var nodeHeight 			= $node.find('> a').height();
				var containerScrollTop 	= this.$.scrollTop();
				var containerHeight 	= this.$.height();
				var treeHeight 			= this.model.$tree.height();
				var newScrollTop;

				// scroll correction possible
				if(containerHeight < treeHeight){
					if(nodeOffsetTop < containerScrollTop){
						newScrollTop = (nodeOffsetTop - (3 * nodeHeight));
					} else if (nodeOffsetTop > (containerScrollTop + containerHeight - nodeHeight)){
						newScrollTop = (nodeOffsetTop - containerHeight + (4 * nodeHeight));
					}
				}

				if(newScrollTop !== undefined){
					this.$.scrollTop(Math.min(Math.max(newScrollTop, 0), treeHeight - containerHeight));
				}
			} catch (error) {
				// prevent scroll to errors from blocking the rest of the code execution
				console.error(error);
			}
		},

		/**
		 * deselect node according to given nodeIndex
		 *
		 * @param   nodeIndex   int - nodeIndex
		 */
		deselectNode: function(nodeIndex){
			this.refresh$Instances().jstree(true).deselect_node(nodeIndex);
		},

		/**
		 * deselect all nodes
		 */
		deselectAllNodes: function(){
			this.refresh$Instances().jstree(true).deselect_all(true);
		},

		/**
		 * this function returns the nodeIndexes of the parent- and all neighbour nodes of the given nodeIndex (given nodeIndex inclusive).
		 *
		 * @param   nodeIndex
		 * @return [] - list of indexes (may be empty)
		 */
		getClosestNodes: function(nodeIndex){
			var indexes = [];
			var parentIndex = this.model.$tree.jstree(true).get_parent(nodeIndex);
			if(parentIndex){
				indexes.push(parentIndex);
				var $children = this.model.$tree.jstree(true).get_children_dom(parentIndex);
				$children.each(function(){
					indexes.push(this.getAttribute('id'));
				});
			}
			return indexes;
		},

		/**
		 * this function returns the actual trees node entry identified by the given nodeIndex
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns {} - jsTree node entry
		 */
		getNode: function(nodeIndex){
			return this.model.$tree.jstree(true).get_node(nodeIndex);
		},

		/**
		 * this function returns the node data identified by the given nodeIndex.
		 * NOTE: this nodeData is the jsTree independent one.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @returns {} - nodeData (undefined in an error case)
		 */
		getNodeData: function(nodeIndex){
			if(this.resourceData.treeData.nodes) return this.resourceData.treeData.nodes[nodeIndex];
			return undefined;
		},

		/**
		 * this function returns the node data identified by the given nodeIndex and all of its childrens' node data.
		 *
		 * @param   nodeIndex       int - nodeIndex
		 * @param   includeParent	boolean - should the nodeData of the given nodeIndex be included or not.
		 * @returns {} - nodeData of all elements found (starting with parent node lead by all its children in a flat form).
		 * 			used index is the nodeIndex of the corresponding nodes
		 */
		getNodeChildrenData: function(nodeIndex, includeParent){
			var nodes = this.model.$tree.jstree(true).get_json() || [];
			var identifiedNodes = {};
			var parentNodeLevel = -1;
			this.traverseNodes(nodes, true, function(node, level){
				if(node.id == nodeIndex){
					parentNodeLevel = level;
					if(includeParent){
						identifiedNodes[node.id] = (this.resourceData.treeData.nodes || {})[node.id];
					}
				} else if(parentNodeLevel > -1 && parentNodeLevel < level){
					identifiedNodes[node.id] = (this.resourceData.treeData.nodes || {})[node.id];
				} else {
					parentNodeLevel = -1;
				}
			});

			return identifiedNodes;
		},

		/**
		 * this function returns if the given pluginName is supported this tree.
		 *
		 * @param   pluginName      string - pluginName
		 * @returns boolean
		 */
		hasPlugin: function(pluginName){
			return (this.config && this.config.treeConfig && this.config.treeConfig.plugins && this.config.treeConfig.plugins.indexOf(pluginName) >= 0);
		},

		/**
		 * this function returns the nodeEntries which are checked in case of the checkbox plugin usage.
		 *
		 * @param   fullDataSet     boolean - should the full data set be returned or not.
		 * @returns []
		 */
		getCheckedNodes: function(fullDataSet){
			// check if active tree has a checkbox plugin
			if(this.hasPlugin('checkbox')) return this.model.$tree.jstree(true).get_checked(fullDataSet);
			return [];
		},

		/**
		 * this function checks all nodes within this tree.
		 */
		checkAllNodes: function(){
			this.model.$tree.jstree(true).check_all();
		},

		/**
		 * this function unchecks all nodes within this tree.
		 */
		uncheckAllNodes: function(){
			this.model.$tree.jstree(true).uncheck_all();
		},

		/**
		 * this function is used to check the nodes identified by the given nodeIndexes param.
		 *
		 * @param   nodeIndexes     [] - list of node Indexes or list of objects like { id: <nodeIndex>, ... }
		 */
		checkNodes: function(nodeIndexes){
			var tree = this.model.$tree.jstree(true);
			// prevent jsTree from checking all child nodes if one parent will be checked
			var threeState = tree.settings.checkbox.threeState;
			var cascade = tree.settings.checkbox.cascade;
			tree.settings.checkbox.threeState = false;
			tree.settings.checkbox.cascade = '';
			tree.check_node(nodeIndexes);
			tree.settings.checkbox.threeState = threeState;
			tree.settings.checkbox.cascade = cascade;
		},

		/**
		 * this function is used to uncheck the nodes identified by the given nodeIndexes param.
		 *
		 * @param   nodeIndexes     [] - list of node Indexes or list of objects like { id: <nodeIndex>, ... }
		 */
		uncheckNodes: function(nodeIndexes){
			var tree = this.model.$tree.jstree(true);
			var threeState = tree.settings.checkbox.threeState;
			var cascade = tree.settings.checkbox.cascade;
			tree.settings.checkbox.threeState = false;
			tree.settings.checkbox.cascade = '';
			// prevent jsTree from checking all child nodes if one parent will be unchecked
			tree.uncheck_node(nodeIndexes);
			tree.settings.checkbox.threeState = threeState;
			tree.settings.checkbox.cascade = cascade;
		},

		/**
		 * this function is used to actualize the filterValue within the search plugin of jstree limited by
		 * the given nr of milliseconds in filterDelay param to prevent mass filter refresh.
		 *
		 * @param filterValue       string - what you want to find
		 * @param filterDelay       int - nr of milliseconds delay
		 */
		search: function(filterValue, filterDelay){
			var self = this;
			if(this.model.searchTimeout) clearTimeout(this.model.searchTimeout);

			this.model.searchTimeout = setTimeout(function(){
				if(self.hasPlugin('search')){
					self.model.$tree.jstree(true).search(filterValue);
				}
			}, filterDelay);
		},

		/**
		 * returns true if jsTree on ready event has been triggered.
		 *
		 * @returns boolean
		 */
		isReady: function(){
			return !!(this.refresh$Instances().hasClass('jstree-ready'));
		},

		refresh$Instances: function(init){
			if(!init) this.refresh$();

			this.model.$tree = this.$.find('> .tree');
			this.model.$contextMenu = this.$.find('> .contextMenu');

			return this.model.$tree;
		},

		/**
		 * backup states of tree.
		 * opposite function to restoreState.
		 */
		backupState: function(){
			var self = this;

			// backup scroll position
			self.model.stateBackup = {
				scrollTop: self.$.scrollTop(),
				nodeStates: {}
			};

			// backup node states
			var nodes = this.model.$tree.jstree(true).get_json(undefined, { flat: true }) || [];
			nodes.forEach(function(node){
				self.model.stateBackup.nodeStates[node.id] = {
					index: 	node.id,
					state: 	node.state
				};
			});
		},

		/**
		 * restore opened- and enabled-states of tree.
		 * opposite function to backupState.
		 */
		restoreState: function(){
			// restore nodes opened- and enabled-state
			var tree = this.model.$tree.jstree(true);
			utils.forEachReverse((this.model.stateBackup || {}).nodeStates || {}, function(nodeData, nodeKey){
				var index 	= nodeKey;
				var state 	= nodeData.state || {};
				var node 	= tree.get_node(index);
				if(state.opened) 	tree.open_node(node, undefined, false);
				else 				tree.close_node(node, false);
				if(state.disabled) 	tree.disable_node(node);
				else 				tree.enable_node(node);
			});

			// restore scroll position
			if((this.model.stateBackup || {}).scrollTop > 0){
				this.$.scrollTop(this.model.stateBackup.scrollTop);
			}
			this.model.stateBackup = {};
		},

		/**
		 * this function is used to tell the jsTree instance what to do onReady according to the trees config.
		 * e.g., close all nodes located at a higher level than configured to be open.
		 *
		 * @param config
		 */
		treeInitByConfig: function(config){
			var jstree = this.model.$tree.jstree(true);
			var nodes = jstree.get_json() || [];

			// close all unnecessary levels
			if(config.maxOpenedLevelOnInit){
				this.traverseNodes(nodes, false, function(node, level){
					if(level >= config.maxOpenedLevelOnInit) jstree.close_node(node, false);
				});
			}
		},

		/**
		 * this function is used to traverse over a nodes tree given by jstree instances.
		 *
		 * @param nodes				[] - list of nodes - jstree.get_json()
		 * @param lateDescending	boolean - used to decide the fucntion should use early- or late-descending
		 * @param callback			function - callback function used to be applied on each node - function(node, level){ ... }
		 * @param level				int - level
		 * 							NOTE: prevent using this parameter. it is used for internal purposes only!
		 */
		traverseNodes: function(nodes, lateDescending, callback, level){
			var n;
			level = level || 1;
			for(n in nodes){
				if(lateDescending) 		callback.apply(this, [nodes[n], level]);
				if(nodes[n].children)	this.traverseNodes(nodes[n].children, lateDescending, callback, level + 1);
				if(!lateDescending) 	callback.apply(this, [nodes[n], level]);
			}
		}
	},

	hooks: {
		attach: function($element, options) {
			// init jstree if necessary
			if(this.resourceData.treeData && this.resourceData.treeData.tree){
				if(this.resourceData.treeData.nodes){
					var self = this;
					self.config.minIndex = 0;
					self.config.maxIndex = utils.collectionSize(this.resourceData.treeData.nodes);

					utils.forEach(this.resourceData.treeData.nodes, function(node, nodeIndex){
						if(node.sort != undefined){
							self.config.minSortValue = Math.min(self.config.minSortValue, node.sort);
							self.config.maxSortValue = Math.max(self.config.maxSortValue, node.sort);
						}
					});
				}

				if(options.refreshResourcesOnly){
					var tree = this.refresh$Instances(true).jstree(true);
					var threeState = tree.settings.checkbox.threeState;
					var cascade = tree.settings.checkbox.cascade;
					tree.settings.checkbox.threeState = false;
					tree.settings.checkbox.cascade = '';
					tree.refresh(true, true);
					tree.settings.checkbox.threeState = threeState;
					tree.settings.checkbox.cascade = cascade;
				} else {
					if(this.actualParentComponent && typeof this.actualParentComponent.treeCoreData === 'function'){
						this.refresh$Instances(true).jstree(utils.merge(this.config.treeConfig, { core: { data: function(){ return self.actualParentComponent.treeCoreData.apply(self.actualParentComponent, [self.resourceData.treeIndex].concat(Object.values(arguments))); } }}));
					} else {
						this.refresh$Instances(true).jstree(utils.merge(this.config.treeConfig, { core: { data: this.resourceData.treeData.tree }}));
					}
				}
			}
		}
	}
};